/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'fabric.emoji.add.custom.emoji.label': 'オリジナルの絵文字を追加',
  'fabric.emoji.add.label': '絵文字を追加',
  'fabric.emoji.cancel.label': 'キャンセル',
  'fabric.emoji.categories.label': '絵文字のカテゴリを選択',
  'fabric.emoji.categories.search.results': '検索結果',
  'fabric.emoji.category.activity': 'アクティビティ',
  'fabric.emoji.category.all.uploads': 'すべてのアップロード',
  'fabric.emoji.category.flags': '旗',
  'fabric.emoji.category.foods': 'フード & ドリンク',
  'fabric.emoji.category.frequent': 'よく使うもの',
  'fabric.emoji.category.nature': '自然',
  'fabric.emoji.category.objects': 'オブジェクト',
  'fabric.emoji.category.people': '人',
  'fabric.emoji.category.places': '旅行 & 場所',
  'fabric.emoji.category.productivity': 'アトラシアンと生産性',
  'fabric.emoji.category.symbols': '記号',
  'fabric.emoji.category.user.uploads': 'あなたのアップロード',
  'fabric.emoji.choose.file.screenReaderDescription':
    '絵文字のファイルを選択します。選択できるファイルは JPG、PNG、GIF の各形式で、サイズ制限は最大 1 MB です',
  'fabric.emoji.choose.file.title': 'ファイルを選択',
  'fabric.emoji.delete.description': 'この絵文字のすべての既存のインスタンスを{emojiShortName}と置き換えます',
  'fabric.emoji.delete.label': '削除',
  'fabric.emoji.delete.screenreader.tooltip': '{shortName} の絵文字を削除するには、Backspace キーを押します',
  'fabric.emoji.delete.title': '絵文字を削除',
  'fabric.emoji.delete.tooltip': '削除',
  'fabric.emoji.emojipicker.emoi.roledescription': '絵文字ボタン',
  'fabric.emoji.emojipicker.error': 'エラー!',
  'fabric.emoji.error.delete.failed': '削除できませんでした',
  'fabric.emoji.error.image.too.big': '選択した画像は 1 MB を超えています',
  'fabric.emoji.error.invalid.image': '選択した画像は無効です。',
  'fabric.emoji.error.upload.failed': 'アップロードできませんでした',
  'fabric.emoji.error.upload.timeout': 'アップロードがタイムアウト',
  'fabric.emoji.image.requirements': 'JPG、PNG、GIF。最大サイズ 1 MB。',
  'fabric.emoji.name.ariaLabel': '新しい絵文字の名前を入力する',
  'fabric.emoji.picker': '絵文字ピッカー',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {結果を検索} other {絵文字}}',
  'fabric.emoji.pickerlist.tabpanel': '絵文字アクションとリスト パネル',
  'fabric.emoji.placeholder': '例: こんにちは',
  'fabric.emoji.preview': '新しい絵文字{emoji}は素敵ですね',
  'fabric.emoji.preview.title': 'プレビュー',
  'fabric.emoji.retry.label': '再試行',
  'fabric.emoji.search.label': '絵文字の名前',
  'fabric.emoji.search.placeholder': '検索',
  'fabric.emoji.search.status': 'すべての絵文字を表示',
  'fabric.emoji.search.status.count': '{count} 件の絵文字が見つかりました',
  'fabric.emoji.select.skin.list.ariaLabel': 'スキン トーン セレクター',
  'fabric.emoji.select.skin.tone.ariaLabel': 'スキン トーンをご選択ください。{selectedTone} を選択済み',
};
